import React from "react";
import "./AndroidProcessSection.css";

const AndroidProcessSection = () => {

    const process = [
        {
            number: "01",
            title: "Discovery & Strategy",
            desc: "We understand your Android app idea, business goals and audience to create the perfect roadmap.",
        },
        {
            number: "02",
            title: "UI/UX Design",
            desc: "Our designers craft premium Android-first interfaces with modern Material Design experiences.",
        },
        {
            number: "03",
            title: "Android Development",
            desc: "Using Kotlin, Java & modern frameworks, we build fast, scalable and secure Android apps.",
        },
        {
            number: "04",
            title: "Testing & Optimization",
            desc: "Every Android application is tested across devices for smooth performance and stability.",
        },
        {
            number: "05",
            title: "Play Store Launch",
            desc: "We handle Play Store publishing, ASO optimization and successful production deployment.",
        },
        {
            number: "06",
            title: "Growth & Support",
            desc: "Continuous updates, feature improvements and scaling support for long-term app success.",
        },
    ];

    return (
        <>
            <section className="android-process-section">

                {/* Background */}
                <div className="aps-grid"></div>
                <div className="aps-glow aps-glow1"></div>
                <div className="aps-glow aps-glow2"></div>

                <div className="aps-container">

                    {/* Heading */}
                    <div className="aps-heading">

                        <span className="aps-badge">
                            ANDROID APP PROCESS
                        </span>

                        <h2>
                            Our Android App
                            <span> Development Process</span>
                        </h2>

                        <p>
                            From idea validation to Play Store launch,
                            we create Android applications with premium design,
                            smooth performance and scalable architecture.
                        </p>

                    </div>

                    {/* Timeline */}
                    <div className="aps-timeline">

                        {process.map((item, index) => (
                            <div
                                className="aps-card"
                                key={index}
                                style={{ animationDelay: `${index * 0.15}s` }}
                            >

                                <div className="aps-number">
                                    {item.number}
                                </div>

                                <div className="aps-content">
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>

                                <div className="aps-line"></div>

                            </div>
                        ))}

                    </div>

                </div>

            </section>
        </>
    );
};

export default AndroidProcessSection;